<div class="container">
  <div class="button" (click)="navigateBack()">
    <mat-icon>arrow_back</mat-icon>
    <div class="text">
      {{ 'components.navigate_back.back' | translate }}
    </div>
  </div>
</div>
